// proto/cortado/v1/errdetails/errdetails.proto

// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/errdetails/errdetails.proto (package cortado.v1.errdetails, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/errdetails/errdetails.proto.
 */
export const file_cortado_v1_errdetails_errdetails: GenFile = /*@__PURE__*/
  fileDesc("CiZjb3J0YWRvL3YxL2VycmRldGFpbHMvZXJyZGV0YWlscy5wcm90bxIVY29ydGFkby52MS5lcnJkZXRhaWxzIpIBCgtFcnJvckRldGFpbBIOCgZyZWFzb24YASABKAkSQgoIbWV0YWRhdGEYAiADKAsyMC5jb3J0YWRvLnYxLmVycmRldGFpbHMuRXJyb3JEZXRhaWwuTWV0YWRhdGFFbnRyeRovCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAFCNFoyaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjEvZXJyZGV0YWlscztlcnJkZXRhaWxzcGJiBnByb3RvMw");

/**
 * @generated from message cortado.v1.errdetails.ErrorDetail
 */
export type ErrorDetail = Message<"cortado.v1.errdetails.ErrorDetail"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * @generated from field: map<string, string> metadata = 2;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message cortado.v1.errdetails.ErrorDetail.
 * Use `create(ErrorDetailSchema)` to create a new message.
 */
export const ErrorDetailSchema: GenMessage<ErrorDetail> = /*@__PURE__*/
  messageDesc(file_cortado_v1_errdetails_errdetails, 0);

